import type { LoaderFunctionArgs } from "react-router";
import { redirect } from "react-router";
import PublicLanding from "./public._index";
import { siteConfig } from "../public-landing/siteConfig";

export const meta = () => {
  const title =
    "MagnifyBI - Shopify Wallboards and Live Store Dashboards";

  return [
    { title },
    { name: "description", content: siteConfig.description },
    { name: "robots", content: "index,follow" },
    { property: "og:type", content: "website" },
    { property: "og:site_name", content: "MagnifyBI" },
    { property: "og:title", content: title },
    { property: "og:description", content: siteConfig.description },
    { property: "og:url", content: siteConfig.siteUrl },
    { property: "og:image", content: `${siteConfig.siteUrl}${siteConfig.socialBanner}` },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: siteConfig.description },
    { name: "twitter:image", content: `${siteConfig.siteUrl}${siteConfig.socialBanner}` },
    { tagName: "link", rel: "canonical", href: siteConfig.siteUrl },
  ];
};

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);

  // Preserve existing install/login redirect behavior
  if (url.searchParams.get("shop")) {
    throw redirect(`/app?${url.searchParams.toString()}`);
  }

  return null;
};

export default function LandingPage() {
  return <PublicLanding />;
}
